var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icpBack"},[_c('div',{staticClass:"textInfo",staticStyle:{"margin-top":"80px","margin-bottom":"80px"}},[_vm._v(" Copyright © 2024-2034 Green Wheat Network Technology Co.Ltd All Rights Reserved. ")]),_c('div',{staticClass:"textInfo",staticStyle:{"margin-bottom":"80px"}},[_vm._v("陕ICP备2021011694号")])])
}]

export { render, staticRenderFns }